import _extends from 'babel-runtime/helpers/extends';
export var START_POLLING_NEXT_TUTORING_SESSION = 'START_POLLING_NEXT_TUTORING_SESSION';
export var STOP_POLLING_NEXT_TUTORING_SESSION = 'STOP_POLLING_NEXT_TUTORING_SESSION';
export var LOAD_TUTORING_SCHEDULER_LAUNCH_INFO = 'LOAD_TUTORING_SCHEDULER_LAUNCH_INFO';

var SET_TUTORING_SCHEDULER_LAUNCH_INFO = 'SET_TUTORING_SCHEDULER_LAUNCH_INFO';
var SET_NEXT_TUTORING_SESSION_TIME = 'SET_NEXT_TUTORING_SESSION_TIME';

var initialTutoringState = {
  nextSessionTime: null,
  schedulerLaunchInfo: null
};

export var tutoringReducer = function tutoringReducer() {
  var tutoringState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialTutoringState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  switch (action && action.type) {
    // here is for actions that only want saga side-effects
    case START_POLLING_NEXT_TUTORING_SESSION:
    case STOP_POLLING_NEXT_TUTORING_SESSION:
    case LOAD_TUTORING_SCHEDULER_LAUNCH_INFO:
      return tutoringState;

    case SET_TUTORING_SCHEDULER_LAUNCH_INFO:
      return _extends({}, tutoringState, {
        schedulerLaunchInfo: action.payload.schedulerLaunchInfo
      });

    case SET_NEXT_TUTORING_SESSION_TIME:
      return _extends({}, tutoringState, {
        nextSessionTime: action.payload.nextSessionTime
      });

    default:
      return tutoringState;
  }
};

export var tutoringActions = {
  startPollingNextTutoringSessionTime: function startPollingNextTutoringSessionTime() {
    return { type: START_POLLING_NEXT_TUTORING_SESSION, payload: {} };
  },
  stopPollingNextTutoringSessionTime: function stopPollingNextTutoringSessionTime() {
    return { type: STOP_POLLING_NEXT_TUTORING_SESSION, payload: {} };
  },

  loadTutoringSchedulerLaunchInfo: function loadTutoringSchedulerLaunchInfo() {
    return { type: LOAD_TUTORING_SCHEDULER_LAUNCH_INFO, payload: {} };
  },

  setNextTutoringSessionTime: function setNextTutoringSessionTime(nextSessionTime) {
    return {
      type: SET_NEXT_TUTORING_SESSION_TIME,
      payload: { nextSessionTime: nextSessionTime }
    };
  },
  setTutoringSchedulerLaunchInfo: function setTutoringSchedulerLaunchInfo(schedulerLaunchInfo) {
    return {
      type: SET_TUTORING_SCHEDULER_LAUNCH_INFO,
      payload: { schedulerLaunchInfo: schedulerLaunchInfo }
    };
  }
};

export var tutoringSelectors = {
  nextSessionTime: function nextSessionTime(state) {
    return state.tutoring.nextSessionTime;
  },
  tutoringSchedulerLaunchInfo: function tutoringSchedulerLaunchInfo(state) {
    return state.tutoring.schedulerLaunchInfo;
  }
};